import { eventNameId } from '../fixture-ids';

export const eventNameLegacyAlternates = {
  EVENT_NAME_UPDATED: { idKeys: ['eventNameId'] },
  EVENT_NAME_DELETED: { idKeys: ['eventNameId'] },
};

export const eventNameLegacyFixtures = {
  EVENT_NAME_CREATED: {
    action: 'EVENT_NAME_CREATED',
    debugData: { id: eventNameId, name: 'checkout_completed', description: 'Fires when checkout completes' },
  },
  EVENT_NAME_UPDATED: {
    action: 'EVENT_NAME_UPDATED',
    debugData: { eventNameId, name: 'checkout_completed', description: 'Fires when checkout completes' },
  },
  EVENT_NAME_DELETED: {
    action: 'EVENT_NAME_DELETED',
    debugData: { eventNameId, name: 'checkout_completed', description: 'Fires when checkout completes' },
  },
};
